import {HttpContextToken, HttpErrorResponse} from '@angular/common/http';

/**
 * Set on the single retry of a write request whose cached CSRF token was rejected.
 */
export const CSRF_TOKEN_RETRY = new HttpContextToken<boolean>(() => false);

/**
 * The backend marks CSRF rejections (e.g. a cached token that became stale after re-login)
 * apart from regular 403 "Not enough permissions" responses.
 */
export function isCsrfTokenInvalidError(err: unknown): boolean {
  if (!(err instanceof HttpErrorResponse) || err.status !== 403) return false;

  const body = err.error;
  return body?.csrfTokenInvalid === true
    || (typeof body === 'string' && body.includes('"csrfTokenInvalid"'));
}
